import React, { useState } from 'react';
import { useHybridAuth } from '../HybridAuthProvider';
import { Icon } from '../assets/icons/Icon';
import styles from './LoginPage.module.scss';

const LoginPage: React.FC = () => {
  const { login, isLoading, idpType } = useHybridAuth();
  const [email, setEmail] = useState('');
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setChecking(true);
    setError('');

    try {
      const apiUrl = process.env.REACT_APP_API_URL || '';
      const resp = await fetch(`${apiUrl}/api/v1/auth/check-domain`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      if (!resp.ok) throw new Error('check-domain failed');
      const data = await resp.json();

      if (data.idp_type === 'azure_ad') {
        (window as any).switchToIDP('azure_ad');
      } else {
        if (idpType === 'auth0') {
          login();
        } else {
          (window as any).switchToIDP('auth0');
        }
      }
    } catch (err) {
      setError('Unable to check email domain. Please try again.');
      setChecking(false);
    }
  };

  if (isLoading)
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginContainer__sidebar}>
        <div className={styles.loginContainer__logo}>
          <Icon iconName="WhiteLogo" width="8rem" height="1.88rem" />
        </div>
        <div className={styles.sidebarOverlay}>
          <div className={styles.sidebarTextBlock}>
            <h2 className={styles.sidebarTitle}>FabricShift</h2>
            <h3 className={styles.sidebarSubtitle}>Habit Track</h3>
            <p className={styles.sidebarDesc}>Team members inclusion, personal development and engagement.</p>
          </div>
        </div>
      </div>
      <div className={styles.loginContainer__content}>
        <h1>HabiTrack</h1>
        <p className={styles.loginContainer__desc}>Programme Mode - Leadership Excellence</p>

        <form onSubmit={handleSubmit} style={{ marginBottom: '16px' }}>
          <p style={{ color: '#6c757d', fontSize: '14px', marginBottom: '16px', textAlign: 'center' }}>
            Enter your email to sign in
          </p>

          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your.name@company.com"
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '1px solid #dee2e6',
              borderRadius: '6px',
              fontSize: '15px',
              marginBottom: '12px',
              boxSizing: 'border-box',
            }}
          />

          {error && (
            <p style={{ color: '#dc3545', fontSize: '13px', marginBottom: '12px' }}>{error}</p>
          )}

          <button
            type="submit"
            disabled={checking || !email.trim()}
            style={{
              width: '100%',
              padding: '12px 20px',
              backgroundColor: '#0078d4',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: checking ? 'wait' : 'pointer',
              opacity: checking || !email.trim() ? 0.7 : 1,
            }}
          >
            {checking ? 'Checking...' : 'Continue'}
          </button>
        </form>

        <div className={styles.loginContainer__footer}>
          <small>By continuing, you agree to our <a href="/terms.html">Terms of Service</a> and <a href="/privacy.html">Privacy Policy</a></small>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
